import React from 'react';
import {Bar} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

const EmptyVolumeChart = () => {
    const clickData = {
        datasets: null,
    };
    const mobileView = window.innerWidth < 650;

    return (
        <div className="d-flex flex-column" style={{flex: 1, paddingTop: '15px'}}>
            <div className="entity-chart-title">Volume per Day</div>
            <div style={{
                maxHeight: '300px',
                padding: '10px 0 0',
                // marginBottom: '10px',
                flex: 1,
                opacity: .5
            }}>
                <Bar
                    data={clickData}
                    height={mobileView ? 500 : 300}
                    responsive={false}
                    options={{
                        fillOpacity: 0.3,
                        legend: {
                            display: true,
                        },
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    ticks: {
                                        autoSkip: true,
                                        maxTicksLimit: 7,
                                    },
                                },
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true,
                                    },
                                },
                            ],
                        },
                        plugins: {
                            datalabels: {
                                display: true,
                                color: 'white',

                                borderRadius: 6,
                                font: {
                                    size: 12,
                                },
                                formatter: function(value) {
                                    if(value > 0) {
                                        return value;
                                    } else {
                                        return null;
                                    }
                                },
                            },
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default EmptyVolumeChart;
